import { homeFor } from "./homeRoute";

// Keep authentication separate from permission to enter the product. Older
// approved profiles without the additive fields keep their existing route.
export const requiresSetup = (user) =>
  Boolean(
    user &&
    ((user.productAccess ?? user.product_access) === false ||
      (user.setupStatus ?? user.setup_status) === "pending_approval"),
  );

export const homeForUser = (user) =>
  requiresSetup(user) ? "/setup" : homeFor(user?.role);
